export const LOGIN = "LOGIN";
export const VERIFY_OTP = "VERIFY_OTP";
export const ADD_NAME = "ADD_NAME";
export const SHOW_LOADING = "SHOW_LOADING";
export const LOGGEDIN_USER_DETAILS = "LOGGEDIN_USER_DETAILS";
export const LOGOUT = "LOGOUT";
export const SHOW_LOGING_DIALOG = "SHOW_LOGING_DIALOG";

